import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Input,
    Row,
} from "reactstrap";

import EcommerceOrdersModal from "components/Common/EcommerceOrdersModal";
import CommonTable from "../../../components/Common/TableContainer";
import DocRequiredAddEditModal from "pages/AllCommonModal/DocRequiredAddEditModal/doc-required-add-edit-modal";
import Spinners from "components/Common/Spinner";
import AllCommonFilterModal from "pages/AllCommonFilter/all-common-filter";
import { useDocRequiredContext } from "libs/context/DocRequiredContext";
import { submitDocRequiredFilterData } from "model/DocRequiredModel";
import Loaders from "components/Common/Loaders";
import { usePermissionContext } from "libs/context/PermissionContext";

const DocRequired = () => {
    const { permissionData } = usePermissionContext() || {};
    const { fetchDocRequiredContextData, docRequiredContextData } = useDocRequiredContext() || {};
    const [docRequiredAddEditModalOpen, setDocRequiredAddEditModalOpen] = useState(false);
    const [modal1, setModal1] = useState(false);
    const toggleViewModal = () => setModal1(!modal1);
    const [searchQuery, setSearchQuery] = useState("");
    const [docRequiredData, setDocRequiredData] = useState("");
    const [loading, setLoading] = useState(false);
    const [itemId, setItemId] = useState(null);
    const [tableMetaData, setTableMetadata] = useState();
    const [commonFilterModalOpen, setCommonFilterModalOpen] = useState(false);

    const initialState = {
        name: "",
        status: true,
    };
    const [formData, setFormData] = useState(initialState);

    const filteredData = useMemo(() => {
        if (!searchQuery?.trim()) return docRequiredData;

        return docRequiredData?.filter((item) =>
            Object.values(item).some((val) =>
                String(val).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [docRequiredData, searchQuery]);

    const docRequiredActionPermissions = useMemo(
        () => ({
            canCreate: Boolean(permissionData?.DocumentRequiredAccess),
            canEdit: Boolean(permissionData?.DocumentRequiredAccess),
        }),
        [permissionData]
    );

    const hasAnyDocRequiredRowAction = useMemo(
        () => docRequiredActionPermissions.canEdit,
        [docRequiredActionPermissions]
    );

    const handleEdit = (row) => {
        setItemId(row?.id || row?.jobCategoryId);
        setDocRequiredAddEditModalOpen(true);
    };

    useEffect(() => {
        fetchDocRequiredContextData();
        getDocRequiredList();
    }, []);

    useEffect(() => {
        const valueReModified = docRequiredContextData?.table?.columns?.map((col) => ({
            Header: col?.title,
            accessor: col?.field,
        }));
        setTableMetadata(valueReModified);
    }, [docRequiredContextData]);

    const getDocRequiredList = async () => {
        setLoading(true);
        const response = await submitDocRequiredFilterData({});
        const listData = response?.data;
        const valueReModified = listData?.map((item) => ({
            ...item,
            ID: item?.id || item?.jobCategoryId,
        }));
        if (response) {
            setDocRequiredData(valueReModified);
        } else {
            setDocRequiredData([]);
        }
        setLoading(false);
    };

    const handleFilterSubmit = async (data) => {
        setLoading(true);
        const response = await submitDocRequiredFilterData(data);
        const filterData = response?.data;
        if (response) {
            setDocRequiredData(filterData);
        } else {
            setDocRequiredData([]);
        }
        setLoading(false);
        setCommonFilterModalOpen(false);
    };

    const handleSearchSubmit = async (value) => {
        setLoading(true);
        const payload = { search: value };
        const response = await submitDocRequiredFilterData(payload);
        const searchData = response?.data;
        if (response) {
            setDocRequiredData(searchData);
        } else {
            setDocRequiredData([]);
        }
        setLoading(false);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* View Modal */}
                    <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center">
                                <h5 className="fw-bold mb-3">Doc Required</h5>

                                {docRequiredActionPermissions.canCreate ? (
                                    <Col xs="12" md="4" className="text-md-end mt-2 mt-md-0">
                                        <Button
                                            color="primary"
                                            onClick={() => {
                                                setItemId(null);
                                                setDocRequiredAddEditModalOpen(true);
                                                setFormData(initialState);
                                            }}
                                        >
                                            + Create
                                        </Button>
                                    </Col>
                                ) : null}
                            </div>
                            <hr />

                            <Row className="align-items-center g-2 mb-4">
                                <Col xs="12" md="8">
                                    <div className="d-flex border rounded w-100 category-search-input">
                                        <Input
                                            type="text"
                                            placeholder="Search by name"
                                            className="border-0"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e?.target?.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSearchSubmit(searchQuery?.trim());
                                                }
                                            }}
                                        />
                                        <Button
                                            className="search-icon-button"
                                            onClick={() => handleSearchSubmit(searchQuery?.trim())}
                                        >
                                            <i className="fa fa-search"></i>
                                        </Button>
                                    </div>
                                </Col>

                            </Row>

                            {(!loading && docRequiredData?.length && tableMetaData?.length) ? (
                                <CommonTable
                                    columns={tableMetaData}
                                    data={filteredData}
                                    isActionRequired={hasAnyDocRequiredRowAction}
                                    onEdit={
                                        docRequiredActionPermissions.canEdit ? handleEdit : undefined
                                    }
                                    isEditAccess={docRequiredActionPermissions.canEdit}
                                    isCheckboxLeftSide={false}
                                    isPagination={false}
                                    setCommonFilterModalOpen={setCommonFilterModalOpen}
                                    pageName={"Doc Required"}
                                />
                            ) : (
                                // <Card className="border mb-3">
                                //     <CardBody>
                                //         <Spinners setLoading={setLoading} />
                                //     </CardBody>
                                // </Card>
                                <Loaders />
                            )}
                        </CardBody>
                    </Card>

                    {/* 🧩 Add/Edit Modal */}
                    <DocRequiredAddEditModal
                        setDocRequiredAddEditModalOpen={setDocRequiredAddEditModalOpen}
                        docRequiredAddEditModalOpen={docRequiredAddEditModalOpen}
                        getDocRequiredList={getDocRequiredList}
                        itemId={itemId}
                        setDocRequiredData={setDocRequiredData}
                        setFormData={setFormData}
                        formData={formData}
                        totalData={docRequiredData}
                    />
                    <AllCommonFilterModal
                        setCommonFilterModalOpen={setCommonFilterModalOpen}
                        commonFilterModalOpen={commonFilterModalOpen}
                        modalTitle="Doc Required"
                        handleSubmit={handleFilterSubmit}
                        filterData={docRequiredContextData?.filters}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

DocRequired.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(DocRequired);
